<script setup lang="ts">
import { LottieAnimation } from 'lottie-web-vue';
import loadingAnimation from '@/assets/loadingAnimation.json';

/**
 * EzTableのローディング状態表示コンポーネント
 * テーブル全体がローディング中であることを表示する
 */

/**
 * Props定義
 */
interface Props {
  /** ローディングメッセージ（省略可） */
  message?: string;
  /** カスタムCSSクラス（省略可） */
  customClass?: string;
}

const props = withDefaults(defineProps<Props>(), {
  message: '',
  customClass: '',
});
</script>

<template>
  <div :class="['ez-table-loading-state', customClass]">
    <div class="ez-table-loading-state__content">
      <LottieAnimation :animation-data="loadingAnimation" :loop="true" :auto-play="true" class="ez-table-loading-state__animation" />
      <p v-if="message" class="ez-table-loading-state__message">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ez-table-loading-state {
  display: grid;
  place-items: center;
  padding: 48px 24px;
  height: 90%;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  &__message {
    font-size: 14px;
    color: #666;
    text-align: center;
    margin: 0;
    font-weight: 400;
  }
}
</style>
